<script>
export default {
  props: {
    campaignOverview: {
      type: Object,
      required: true,
    },
  },
}
</script>

<template>
  <div class="card flex-fill">
    <div class="card-body">
      <h5 class="mb-2 mb-xl-4">Performance</h5>

      <div class="row">
        <div class="col-6 col-lg-4 mb-4 mb-xl-5">
          <div class="row">
            <div class="col-12 mb-1 font-size-15">Published posts</div>
            <div class="col-12 h-100"><h4 class="mb-0">{{ campaignOverview.performance.published_posts_count.value }}</h4></div>
          </div>
        </div>
        <div class="col-6 col-lg-4 mb-4 mb-xl-5">
          <div class="row">
            <div class="col-12 mb-1 font-size-15">Total Likes</div>
            <div class="col-12 h-100"><h4 class="mb-0">{{ campaignOverview.performance.likes.value | compactNumber }}</h4></div>
          </div>
        </div>
        <div class="col-6 col-lg-4 mb-4 mb-xl-5">
          <div class="row">
            <div class="col-12 mb-1 font-size-15">Total Comments</div>
            <div class="col-12 h-100"><h4 class="mb-0">{{ campaignOverview.performance.comments.value | compactNumber }}</h4></div>
          </div>
        </div>
        <div class="col-6 col-lg-4 mb-4 mb-xl-5">
          <div class="row">
            <div class="col-12 mb-1 font-size-15">Total Reach</div>
            <div class="col-12 h-100"><h4 class="mb-0">{{ campaignOverview.performance.reach.value | compactNumber }}</h4></div>
          </div>
        </div>

        <div class="col-6 col-lg-4 mb-4 mb-xl-5">
          <div class="row">
            <div class="col-12 mb-1 font-size-15">Avg. Reach Per Post</div>
            <div class="col-12 h-100"><h4 class="mb-0">{{ campaignOverview.performance.average_reach_per_post.value | compactNumber }}</h4></div>
          </div>
        </div>
        <div class="col-6 col-lg-4 mb-4 mb-xl-5">
          <div class="row">
            <div class="col-12 mb-1 font-size-15">Avg. Eng. Rate Per Post</div>
            <div class="col-12 h-100"><h4 class="mb-0">{{ campaignOverview.performance.average_engagement_rate_per_post.value * 100 | compactNumber }}%</h4></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
